import React, { useState } from 'react';

function MobileDoctorHelpCenter({ onBack }) {
  const [openFaq, setOpenFaq] = useState(null);

  const faqs = [
    { q: 'How do I find a patient?', a: 'Go to Search tab → Enter Patient ID or scan QR code from patient\'s home screen.' },
    { q: 'How does access request work?', a: 'You send a request to the patient. They receive a notification and approve/deny. Once approved, you can view their reports.' },
    { q: 'How long does access last?', a: 'Access is valid for 24 hours after patient approval. After that, you need to send a new request.' },
    { q: 'How do I generate AI Summary?', a: 'Open patient detail → AI Summary tab → Select time period → Click Generate Summary.' },
    { q: 'Can I download patient reports?', a: 'Yes! Open patient detail → Reports tab → Click Download on any report.' },
    { q: 'How is patient data protected?', a: 'All data is encrypted. Access is strictly controlled by patient consent. We follow HIPAA & ABDM standards.' },
  ];

  return (
    // REMOVED 'pt-16' TO ELIMINATE THE TOP GAP
    <div className="pb-6 bg-[#f9f9fc] min-h-full" style={{ fontFamily: 'Inter, sans-serif' }}>
      
      {/* SUB-SCREEN HEADER */}
      <div className="flex items-center gap-3 px-4 py-3 bg-white border-b border-gray-100 sticky top-0 z-10">
        <button onClick={onBack} className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-gray-100 active:scale-95 transition-all">
          <span className="material-symbols-outlined text-gray-500">arrow_back</span>
        </button>
        <span className="font-black text-[#0d1b2a] text-base">Help Center</span>
      </div>

      <div className="px-4 pt-4 pb-4 space-y-4">
        {/* Banner */}
        <div className="rounded-2xl p-5 text-white text-center shadow-xs" style={{ background: 'linear-gradient(135deg, #0B3C95, #1E65FF)' }}>
          <span className="material-symbols-outlined text-4xl mb-2 block" style={{ fontVariationSettings: '"FILL" 1' }}>help</span>
          <h2 className="font-black text-lg">How can we help?</h2>
          <p className="text-white/70 text-xs mt-1">Find answers to common questions below</p>
        </div>

        {/* FAQs */}
        <div>
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2 ml-1">FAQs</p>
          <div className="space-y-2">
            {faqs.map((faq, i) => (
              <div key={i} className="bg-white rounded-2xl border border-gray-100 overflow-hidden" style={{ boxShadow: '0px 4px 20px rgba(0,0,0,0.05)' }}>
                <button onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  className="w-full flex items-center justify-between px-4 py-3 text-left active:scale-[0.99] transition-all">
                  <p className="font-semibold text-sm text-[#1a1c1e] pr-4">{faq.q}</p>
                  <span className="material-symbols-outlined text-gray-400 shrink-0 transition-transform duration-200"
                    style={{ transform: openFaq === i ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                    expand_more
                  </span>
                </button>
                {openFaq === i && (
                  <div className="px-4 pb-4">
                    <p className="text-sm text-gray-500 leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Contact */}
        <div>
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2 ml-1">Contact Us</p>
          <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden" style={{ boxShadow: '0px 4px 20px rgba(0,0,0,0.05)' }}>
            {[
              { icon: 'mail', label: 'Email Support', desc: 'support@myhealthjournal.in' },
              { icon: 'phone', label: 'Call Support', desc: '+91 1800-XXX-XXXX' },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-3 px-4 py-3 border-b border-gray-50 last:border-b-0">
                <div className="w-9 h-9 bg-[#0B3C95]/10 rounded-xl flex items-center justify-center">
                  <span className="material-symbols-outlined text-[#0B3C95] text-lg">{item.icon}</span>
                </div>
                <div>
                  <p className="font-semibold text-sm text-[#1a1c1e]">{item.label}</p>
                  <p className="text-xs text-gray-400">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MobileDoctorHelpCenter;